<template lang="pug">
    GmapMap(
        ref="mapRef"
        class="map-app__map-view-main"
        :center="mapLatLng"
        :zoom="zoom"
        :options="{disableDefaultUI : true, gestureHandling: 'cooperative'}"
        map-type-id="roadmap"
    )
        GmapMarker(
            v-for="m in highlightsArr"
            :key="m.link"
            :clickable="true"
            :position="{lat: m.lat, lng: m.lng}"
            :icon="{url: `/www_visitnewcastle/map-assets/img/marker-${m.tour_step}.svg`, anchor: iconPoint }"
            :link-name="m.link"
            @click="markerClickHandler(m.link, $event, m.tour_step)"
        )
        //- GmapInfoWindow(
        //-     v-for="m in highlightsArr"
        //-     :key="`infowindow-${m.link}`"
        //-     :position="{lat: m.lat, lng: m.lng}"
        //- )
        GmapPolyline(
            :path="polyline"
            :options={
                strokeColor: '#ED1940',
                strokeOpacity: 0,
                icons: [{
                    icon: {
                        path: 'M 0,-1 0,1',
                        strokeOpacity: 1,
                        scale: 4
                    },
                    offset: '0',
                    repeat: '20px'
                }],
            }
        )
</template>

<script>
import { gmapApi } from 'vue2-google-maps'

export default {
    name: 'mapView',
    props: ['data'],
    data() {
        return {
            mapLatLng: {
                lat: 0,
                lng: 0,
            },
            initalMapLatLng: {
                lat: 0,
                lng: 0,
            },
            highlightsArr: [],
            bounds: [],
            polyline: [],
            zoom: 14,
            initialZoom: 0,
            initialCenter: 0,
            nodeActive: false,
        }
    },
    mounted() {
        console.log('mapView data', this.data)
        this.mapLatLng.lat = this.data.lat
        this.mapLatLng.lng = this.data.lng
        // this.mapLatLng.lat = -32.92715
        // this.mapLatLng.lng = 151.77647
        console.log('mapView this.mapLatLng', this.mapLatLng)
        this.highlightsArr = this.data.highlightsArr

        // on map init
        this.$nextTick(() => {
            this.$refs.mapRef.$mapPromise.then((map) => {
                // get initial bounds
                let initialBounds = this.findBounds(this.highlightsArr)
                this.initalMapLatLng = initialBounds.getCenter()

                //save bounds for reuse
                this.bounds = initialBounds
                this.polyline = this.createPolylineArray(this.highlightsArr)

                // call bounds
                this.fitBounds(initialBounds)

                //save zoom and center for reuse
                this.initialZoom = map.getZoom()
                this.initialCenter = map.getCenter()
            })
        })

        // on navigating to itinerary node
        this.$root.$on('itinerary-node-active', (arr) => {
            let singleNodeBounds = {lat: arr.lat, lng: arr.lng}
            // this.zoom = 16
            // this.$refs.mapRef.setZoom(18)
            this.$refs.mapRef.panTo(singleNodeBounds)
        })

        // on navigating to highlight page
        this.$root.$on('tab-page-active', (page) => {
            // this.$refs.mapRef.setZoom(this.initialZoom)
            this.$refs.mapRef.panTo(this.initalMapLatLng)
            // this.$refs.mapRef.fitBounds(this.bounds, { padding: 50})
        })
    },
    methods: {
        markerClickHandler(link, e, tourStep) {
            console.log('link, e, tourStep', link, e, tourStep)
            this.$router.push(`/highlight/${link}`).catch(err => {
                console.info(err)
            })
        },
        createPolylineArray(arr) {
            let polylineArr = []
            arr.forEach((m) => {
                polylineArr.push({lat: m.lat, lng: m.lng})
            })
            console.log('createPolylineArray polylineArr', polylineArr)
            return polylineArr
        },
        findBounds(arr) {
            const bounds = new google.maps.LatLngBounds()
            arr.forEach((m) => {
                bounds.extend({lat: m.lat, lng: m.lng})
            })
            return bounds
        },
        fitBounds(bounds) {
            this.$refs.mapRef.fitBounds(bounds, 0)
        },
    },
    watch: {
        highlightsArr() {
            this.fitBounds(this.bounds, {padding: 20})
        }
    },
    computed: {
        google() {
            return gmapApi()
        },
        iconPoint() {
            if (this.google) {
                return new google.maps.Point(20,20)
            } else {
                return null
            }
        }
    }
}
</script>

<style lang="scss">
.map-app__map-view-main {
    width: 100%;
    height: 100%;
}
</style>